

export default function showCards ($) {

	const body = $('body');

	// Wire up play button/thumbnail on all places where video rows can happen (Home/Producer/Shows/CS Shows)
	if (body.hasClass("home") || body.hasClass("single-producer") || body.hasClass("single-show") || body.hasClass("single-cs-show") ) {

		$('.play-icon').on('click', function () {


			let thisCard = $(this).closest('.video-card')

			let videoID = thisCard.find('.video-js').attr('id');
			let videoPlayer = videojs.getPlayer(videoID);

			thisCard.find('.video-thumbnail-wrapper').addClass('hide-thumbnail');
			thisCard.find('.video-embed-container').addClass('show-video');
			videoPlayer.play();


		});

	}

	// Hide and show info panel on studio shows
	if (body.hasClass("single-cs-show")) {
		$('.show-card-info-banner').click(function () {

			let thisRow = $(this).closest('.single-image-info-panel');

			// infoPanel.not(thisRow).addClass('panel-hidden')
			thisRow.find('.show-card-info-panel').removeClass('panel-hidden');
			thisRow.find('.show-card-info').addClass('info-hidden');

			$('.close-bar-1').removeClass('rotate-1');
			$('.close-bar-2').removeClass('rotate-2');

		});

		$(".card-close").click(function () {
			$('.close-bar-1').addClass('rotate-1');
			$('.close-bar-2').addClass('rotate-2');

			let thisRow = $(this).closest('.single-image-info-panel');
			thisRow.find('.show-card-info-panel').addClass('panel-hidden');
			thisRow.find('.show-card-info').removeClass('info-hidden')

		});
	}
}
